import { RecentChangeMetric } from '../../../../services/dtos/riskProducts/dashboard/recentChangeList.dto';

export const isCreMetric = (metric: string): boolean => {
  return metric === RecentChangeMetric.CRE;
};
